import {DateTime} from "luxon";

const now = () => DateTime.local();
export default now;
